// Words for a status, for badges that only have the raw value from the API. StatusBadge looks the
// value up here (any case, any separator: 'IN_PROGRESS', 'in-progress' and 'inProgress' are one
// key) and shows the label in the user's language; a value that is not listed is shown as plain
// sentence case. Pages that already translate their own label pass it as the badge's children.
const status = {
  en: {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    processing: 'Processing',
    inProgress: 'In progress',
    completed: 'Completed',
    paid: 'Paid',
    refunded: 'Refunded',
    failed: 'Failed',
    cancelled: 'Cancelled',
    expired: 'Expired',
    draft: 'Draft',
    published: 'Published',
    archived: 'Archived',
    open: 'Open',
    closed: 'Closed',
    new: 'New',
    answered: 'Answered',
    unanswered: 'Unanswered',
    resolved: 'Resolved',
    approved: 'Approved',
    rejected: 'Rejected',
    passed: 'Passed',
    partial: 'Partial',
    suspended: 'Suspended',
    banned: 'Banned',
    removed: 'Removed',
    invited: 'Invited',
    prospect: 'Prospect',
    churned: 'Churned',
    enrolled: 'Enrolled',
    scheduled: 'Scheduled',
    uploaded: 'Uploaded',
    generated: 'Generated',
    issued: 'Issued',
    revoked: 'Revoked',
    reserved: 'Reserved',
  },
  ru: {
    active: 'Активен',
    inactive: 'Неактивен',
    pending: 'В ожидании',
    processing: 'В обработке',
    inProgress: 'В процессе',
    completed: 'Завершён',
    paid: 'Оплачено',
    refunded: 'Возвращено',
    failed: 'Ошибка',
    cancelled: 'Отменён',
    expired: 'Истёк',
    draft: 'Черновик',
    published: 'Опубликован',
    archived: 'В архиве',
    open: 'Открыт',
    closed: 'Закрыт',
    new: 'Новый',
    answered: 'С ответом',
    unanswered: 'Без ответа',
    resolved: 'Решён',
    approved: 'Одобрен',
    rejected: 'Отклонён',
    passed: 'Пройден',
    partial: 'Частично',
    suspended: 'Приостановлен',
    banned: 'Заблокирован',
    removed: 'Удалён',
    invited: 'Приглашён',
    prospect: 'Потенциальный',
    churned: 'Ушедший',
    enrolled: 'Записан',
    scheduled: 'Запланировано',
    uploaded: 'Загружено',
    generated: 'Создано',
    issued: 'Выдан',
    revoked: 'Отозван',
    reserved: 'Зарезервировано',
  },
  uz: {
    active: 'Faol',
    inactive: 'Nofaol',
    pending: 'Kutilmoqda',
    processing: 'Jarayonda',
    inProgress: 'Jarayonda',
    completed: 'Tugallangan',
    paid: "To'langan",
    refunded: 'Qaytarilgan',
    failed: 'Muvaffaqiyatsiz',
    cancelled: 'Bekor qilingan',
    expired: "Muddati o'tgan",
    draft: 'Qoralama',
    published: 'Nashr qilingan',
    archived: 'Arxivlangan',
    open: 'Ochiq',
    closed: 'Yopilgan',
    new: 'Yangi',
    answered: 'Javob berilgan',
    unanswered: 'Javobsiz',
    resolved: 'Hal qilingan',
    approved: 'Tasdiqlangan',
    rejected: 'Rad etilgan',
    passed: "O'tdi",
    partial: 'Qisman',
    suspended: "To'xtatilgan",
    banned: 'Bloklangan',
    removed: 'Olib tashlangan',
    invited: 'Taklif qilingan',
    prospect: 'Potensial',
    churned: 'Ketgan',
    enrolled: 'Yozilgan',
    scheduled: 'Rejalashtirilgan',
    uploaded: 'Yuklangan',
    generated: 'Yaratilgan',
    issued: 'Berilgan',
    revoked: 'Bekor qilingan',
    reserved: 'Zaxiralangan',
  },
};

export default status;
